'use strict';

angular.module('webAgro1App').controller('OcorrenciaMaquinaCtrl', function($scope, $rootScope, $q, $location, $routeParams, filterFilter, $filter, Flash,
        OcorrenciasMaquinasService, LoadingService, MessagesService, MaquinasService, PessoasService, ItensManutencaoService) {

  $scope.tiposOcorrenciasMaquinas = TIPOS_OCORRENCIAS_MAQUINAS;
  $scope.tiposControleMaquina = TIPOS_CONTROLE_MAQUINA;

  var defaultDatePickerOptions = {
    showWeeks: false,
    formatDayTitle: 'dd/MM/yyyy'
  };

  $scope.startDatePickerOptions = {
    ...defaultDatePickerOptions,
    maxDate: new Date()
  };

  $scope.dueDatePickerOptions = {
    ...defaultDatePickerOptions,
    minDate: ($scope.newOcorrencia || {}).data || new Date()
  };

  var initialize = function() {
    LoadingService.showLoading();
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.maquina.canManage) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      getFieldsServices();
    }, $rootScope.errorRootInitialize);
  };

  function getFieldsServices() {
    var promises = [
      MaquinasService.list(),
      PessoasService.listMaoDeObra(),
      ItensManutencaoService.list()
    ];

    if ($routeParams.id) {
      promises.push(OcorrenciasMaquinasService.getOcorrenciaMaquina($routeParams.id));
    }

    $q.all(promises).then(function(data) {
      $scope.maquinas = data[0].data || [];
      $scope.operadores = data[1].data || [];
      $scope.itensManutencao = data[2].data || [];
      $scope.newOcorrencia = data[3] || {};

      if ($routeParams.id && !$scope.newOcorrencia.id) {
        $scope.goToIndex();
      }

      if (!$routeParams.id) {
        $scope.newOcorrencia = {
          data: moment().startOf('day').toDate(),
          hora: moment().milliseconds(0).toDate(),
          propriedade: $rootScope.currentPropriedade,
          safra: filterFilter($scope.safras, {current: true})[0],
          status: TIPOS_STATUS_OCORRENCIA_MAQUINA.aberto
        };
      } else {
        $scope.changeMaquina($scope.newOcorrencia.maquina, true);
      }
    }, function() {
      MessagesService.alert('Não foi possível carregar os dados.');
      $scope.goToIndex();
    }).finally(LoadingService.hideLoading);
  }

  var validateHorimetro = function() {
    return !$scope.newOcorrencia.maquina.horimetro_atual
            || $scope.newOcorrencia.maquina.horimetro_atual <= $scope.newOcorrencia.hodometro;
  };

  $scope.save = function(form) {
    if (form.$invalid) {
      return;
    }

    if (!$scope.newOcorrencia.id && !validateHorimetro()) {
      MessagesService.alert(`O ${$scope.tiposControleMaquina[$scope.newOcorrencia.maquina.tipo_controle_manutencao]}
                              precisa ser maior ou igual que o último informado - ${$scope.newOcorrencia.maquina.horimetro_atual}`);
      return;
    }

    LoadingService.showLoading();
    var method = $scope.newOcorrencia.id ? OcorrenciasMaquinasService.update : OcorrenciasMaquinasService.save;
    method($scope.newOcorrencia).then(function(result) {
      $location.path('/ocorrencias_maquinas/' + (result.data[0] || $scope.newOcorrencia.id));
      Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, REGISTRO_SALVO_COM_SUCESSO.msg);
    }, function() {
      Flash.create(FALHA_AO_SALVAR_REGISTRO.type, FALHA_AO_SALVAR_REGISTRO.msg);
    }).finally(LoadingService.hideLoading);
  };

  $scope.goToIndex = function() {
    $location.path('/ocorrencias_maquinas');
  };

  $scope.changeMaquina = function(newMaquina, keepHodometro) {
    if (!newMaquina || $scope.newOcorrencia.id) {
      return;
    }

    LoadingService.showLoading();
    MaquinasService.get(newMaquina.id).then(function(result) {
      var horimetroAtual = +result.data.horimetro_atual;
      if (horimetroAtual) {
        newMaquina.horimetro_atual = +result.data.horimetro_atual;
        if (!keepHodometro) {
          $scope.newOcorrencia.hodometro = horimetroAtual;
        }
      }
    }).catch(function(error) {
      MessagesService.alert('Não foi possível carregar os dados da máquina.');
      $scope.newOcorrencia.hodometro = null;
      console.error('Falha ao caregar horímetro atual da máquina', error);
    }).finally(LoadingService.hideLoading);
  };

  $scope.setMinDueDate = function() {
    $scope.dueDatePickerOptions.minDate = ($scope.newOcorrencia || {}).data || new Date();
    if (($scope.newOcorrencia || {}).dataPrazo && $scope.newOcorrencia.dataPrazo < $scope.newOcorrencia.data) {
      $scope.newOcorrencia.dataPrazo = $scope.newOcorrencia.data;
    }
  };

  initialize();
});
